import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./scss/index.css";
import { Provider } from "react-redux";
import { store } from "./api/actions/store";
import { I18nextProvider } from "react-i18next";
import i18n from "./translation/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <App />
      </Provider>
    </I18nextProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

reportWebVitals();
